import * as React from 'react';
import { SettingsProvider } from '@moovly/moovly-settings';
import { Spinner } from '@moovly/ui';
import useExternalTypeId from '../../../hooks/useExternalTypeId';

const GroupSettingsProvider = ({ children }: { children: React.ReactNode }) => {
  const { externalId, externalType, isLoaded, hasExternalId } = useExternalTypeId();

  if (!isLoaded) return <Spinner />;
  if (!hasExternalId) return <>{children}</>;

  return (
    <SettingsProvider autoSave externalId={externalId} externalType={externalType}>
      {children}
    </SettingsProvider>
  );
};

export default GroupSettingsProvider;
